module.exports = __webpack_public_path__ + "static/media/type.ca577d2e.png";